import { Fragment } from 'react';

import { cn, iaRa } from 'lib/helpers/utility';

import DocText from '../DocText';
import { DOC_TEXT, SUMMARY_WIDTH_CLASS } from '../lib/docStyles';

const SummaryRow = ({ label, value, strong }) => (
  <div
    className={cn(
      'flex items-baseline justify-between gap-x-6',
      strong ? 'mt-0.5 border-0 border-t border-solid border-neutral-900 pt-1.5' : 'py-[3px]'
    )}>
    <DocText
      size="xs"
      className={cn('w-auto', strong ? DOC_TEXT.summaryTotal : DOC_TEXT.summaryLabel)}>
      {label}
    </DocText>
    <DocText
      size="xs"
      className={cn(
        'w-auto whitespace-nowrap tabular-nums',
        strong ? DOC_TEXT.summaryTotal : DOC_TEXT.summaryValue
      )}>
      {value}
    </DocText>
  </div>
);

const DocSummaryRows = ({ rows = [], className, widthClass = SUMMARY_WIDTH_CLASS }) => {
  const visibleRows = iaRa(rows).filter(Boolean);

  if (!visibleRows.length) return null;

  return (
    <div className={cn('flex justify-end', className)}>
      <div className={widthClass}>
        {visibleRows.map((row, index) => (
          <Fragment key={`${row.label}-${index}`}>
            <SummaryRow {...row} />
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default DocSummaryRows;
